import React from 'react'

const CheckYourEmailPage = () => {
  return (
    <div>
        <h1>Registration was successful! Check your Email to verify your account!</h1>
    </div>
  )
}

export default CheckYourEmailPage